import { Button, Container } from '@mui/material'
import React, { useContext } from 'react'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { useCuestionario } from "../hooks/useCuestionario"
import FinalizarCuestionario from '../components/FinalizarCuestionario'
import { TooltipButton } from '../components/commons/TooltipButton'
import { useTranslation } from "react-i18next"
import { styled } from '@mui/material/styles'
import { EjesSkeleton } from '../components/commons/EjesSkeleton'
import { EjesContext } from '../context/EjesContext'
import { GeneralContext } from '../context/GeneralContext'
import { useContestaciones } from '../hooks/useContestaciones'
import { useState, useEffect } from 'react';
import { useUser } from '../hooks/useUser.jsx';
import { useNavigate } from 'react-router-dom';
import { DobleCircularProgressWithLabel } from '../components/commons/DobleCircularProgressWithLabel';
import ReplayIcon from '@mui/icons-material/Replay';
import { Box, Stack } from '@mui/system';
import ModalConfirmar from '../components/commons/ModalConfirmar'
import "../styles/Ejes.css";
import Modal from '../components/commons/Modal'
import { ShowPerfilEmpresarial } from '../components/ShowPerfilEmpresarial'
import { RadarChart } from "../components/Radar.jsx"
import colors from '../theme/colors'
import { usePerfilEmpresarialActual } from '../hooks/perfilEmpresarial/usePerfilEmpresarialActual'
import { ObtenerInformesButtons } from '../components/ObtenerInformesButtons'
import { EjesPDFButtons } from '../components/EjesPDFButtons'
import { EjesFunctionButtons } from '../components/EjesFunctionButtons'
import { EjesCardUI } from '../components/EjesCardUI'
import { useSecurity } from "../hooks/useSecurity"

const IconButton = styled(Button)(({ theme }) => ({
    padding: '6px 6px',
    minWidth: '35px',
    height: '35px'
}));

export const Ejes = () => {
    const { getEjesCuestionario, anularEje, activarEje } = useCuestionario()
    const [listaEjes, setListaEjes] = useState()
    const { reiniciarEje } = useContestaciones()
    const { user } = useUser()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { handleOpenFinalizarCuestionario, loading, setLoading, GetCuestionarioReportEje, GetCuestionarioReportParcial } = useContext(EjesContext)
    const { setIdAxe, setQuestionaryPercentage } = useContext(GeneralContext)
    const [open, setOpen] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false)
    const { perfilEmpresarial } = usePerfilEmpresarialActual();
    const [showPerfilEmpresarial, setShowPerfilEmpresarial] = useState(false)
    const { loadingModal, setLoadingModal } = useContext(GeneralContext)
    useSecurity();

    const handleClose = () => {
        setOpen(false);
        setShowPerfilEmpresarial(false)
    };

    function goToTema(axe) {
        setIdAxe(axe)
        navigate('/Cuestion')
    }
    function volverAMisCuestionarios() {
        navigate("/MisCuestionarios")
    }

    const handleShowInfoModal = () => {
        setShowInfoModal(true)
    }

    function reiniciarEjeFunction(idEje) {
        reiniciarEje(user, idEje)
            .then(
                (ejes) => {
                    setListaEjes(ejes)
                    setLoadingModal(null)
                },
                (y) => {
                    console.error("Error: " + y)
                }
            );
    }


    function anularEjeFunction(idEje) {
        anularEje(user, idEje)
            .then(
                (ejes) => {
                    setListaEjes(ejes)
                    setLoadingModal(null)
                },
                (y) => {
                    console.error("Error: " + y)
                }

            );
    }

    function activarEjeFunction(idEje) {
        activarEje(user, idEje)
            .then(
                (ejes) => {
                    setListaEjes(ejes)
                    setLoadingModal(null)
                },
                (y) => {
                    console.error("Error: " + y)
                }
            );
    }

    useEffect(() => {
        user?.usuario &&
            getEjesCuestionario(user)
                .then(
                    (ejes) => {
                        setListaEjes({ ...ejes })
                        setQuestionaryPercentage(ejes.porcentajeCuestionario)
                    },
                    (promiseError) => {
                        console.error("Error: " + promiseError)
                        
                    }
                );

    }, [user]);

    useEffect(() => {
        if (listaEjes && listaEjes.porcentajeCuestionario === 100) {
            setOpen(true);
        }
    }, [listaEjes])

    return (
        <Grid container
            direction="column"
            justifyContent="center"
        >
            <Box>
                <EjesFunctionButtons volverAMisCuestionarios={volverAMisCuestionarios} setShowPerfilEmpresarial={setShowPerfilEmpresarial} />
            </Box>

            <Modal
                title={t('crearPerfilEmpresarial.titulo')}
                content={<ShowPerfilEmpresarial perfilEmpresarial={perfilEmpresarial} />}
                open={showPerfilEmpresarial}
                close={handleClose}>
                <Button variant="contained" onClick={handleClose}>{t("general.cerrar")}</Button>
            </Modal>
            <Grid item xs={12} >
                <Typography variant='h1' marginY={2}>{t("eje.titulo")}</Typography>
            </Grid>

            <Grid item className='ejesBody'>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    columns={10}
                >
                    <Grid item xs={12} sx={{ marginBottom: "2em", textAlign: 'center' }}>
                        {listaEjes?.porcentajeCuestionario > 0 && (
                            <>
                                <Typography
                                    variant="h2"
                                    textAlign={"center"}
                                    marginBottom={2}
                                >
                                    {t("general.porcentajeTotal")}
                                </Typography>
                                <DobleCircularProgressWithLabel percentage={listaEjes.porcentajeCuestionario} size={120} fontSize={"1.5em"} />
                            </>
                        )}
                    </Grid>
                    {listaEjes ? (
                        <>
                            {listaEjes.ejes.map(eje =>
                                <Grid item xs={12} sm={5} lg={2} key={eje.id_eje}>
                                    <EjesCardUI eje={eje} goToTema={goToTema} />
                                    <Box>
                                        <EjesPDFButtons loading={loading} setLoading={setLoading} eje={eje} listaEjes={listaEjes} activarEjeFunction={activarEjeFunction} anularEjeFunction={anularEjeFunction} GetCuestionarioReportEje={GetCuestionarioReportEje} reiniciarEjeFunction={reiniciarEjeFunction} goToTema={goToTema} />
                                    </Box>
                                </Grid>
                            )}

                            <Grid
                                item
                                xs={12}
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginY: "3rem",
                                }}
                            >
                                <Stack spacing={2} direction="row">
                                    <ObtenerInformesButtons loading={loading} setLoading={setLoading} listaEjes={listaEjes} GetCuestionarioReportParcial={GetCuestionarioReportParcial} handleOpenFinalizarCuestionario={handleOpenFinalizarCuestionario} handleShowInfoModal={handleShowInfoModal} />
                                </Stack>
                                {listaEjes?.porcentajeCuestionario === 100 && (
                                    <FinalizarCuestionario
                                        idCuestionario={listaEjes.id_cuestionario}
                                    />
                                )}
                            </Grid>
                            <Modal
                                title={t("eje.tituloObtenerInformeGlobal")}
                                content={t("eje.bodyObtenerInformeGlobal")}
                                open={showInfoModal}
                            >
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        setShowInfoModal(false);
                                    }}
                                >
                                    {t("general.aceptar")}
                                </Button>
                            </Modal>
                            <Modal
                                title={""}
                                content={t("eje.listaEjes100Modal")}
                                open={open}
                                close={handleClose}
                                center={true}
                            >
                                <Button variant="contained" onClick={handleClose}>{t("general.cerrar")}</Button>
                            </Modal>

                            {/*Este radar se crea en oculto para que salga en el pdf parcial */}
                            <Box sx={{
                                position: "absolute", zIndex: -99, height: { xs: 'auto', md: '550px' }, display: 'flex', alignContent: 'center', justifyContent: 'center'
                            }}>
                                <RadarChart puntuacionesEjes={listaEjes?.puntuacionEje?.length >= 3 ? listaEjes.puntuacionEje : null} calification={"B"} />
                            </Box>
                        </>
                    ) : (
                        <EjesSkeleton />
                    )}
                </Grid>
            </Grid>
        </Grid >
    )
}
